import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const Filter = styled.div`
  margin-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    text-align: center;

    button {
      margin-bottom: ${space.md};
    }
  }
`

export const Materials = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${space.xl3} ${space.lg};

  @media (min-width: ${breakpoint.xl}) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: ${breakpoint.hd}) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export const Button = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: ${space.xl2};
  padding: 0 ${space.md};
  margin-bottom: ${space.xl};
  border-radius: ${borders.sizes.xl};
  border: ${borders.sizes.md} solid ${color.primary.light};
  gap: ${space.xs};
  background-color: ${color.primary.light};
  color: ${color.primary.darker};
  font-size: ${font.size.xsmall};
  font-weight: ${font.weight.medium};
  line-height: ${font.lineHeight.sm};
  transition: all 0.3s ease;

  &:hover {
    text-decoration: none;
  }

  @media (min-width: ${breakpoint.lg}) {
    border-color: ${color.grayscale.light};
    background-color: transparent;

    &:hover {
      border-color: ${color.primary.light};
      background-color: ${color.primary.light};
    }
  }
`

export const MaterialImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: ${space.lg};
  transition: all 0.3s ease;

  @media (min-width: ${breakpoint.lg}) {
    border-radius: ${borders.radius.lg};
    overflow: hidden;
  }
`

export const Material = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 18rem;
  margin-right: ${space.lg};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.lighter};
  cursor: pointer;
  transition: all 0.3s ease;

  @media (min-width: ${breakpoint.lg}) {
    min-width: auto;
    margin-right: 0;
    background-color: transparent;

    &:hover {
      background-color: ${color.grayscale.white};
      box-shadow: 0px 0px 50px #1021331a;

      ${MaterialImage} {
        border-radius: 0;
      }

      ${Button} {
        border-color: ${color.primary.light};
        background-color: ${color.primary.light};
      }
    }
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`

export const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100%;
  min-height: 100%;

  img {
    transition: transform 0.3s ease;
    transform-origin: top left;
    width: auto;
    height: auto;
    max-width: none;
    max-height: none;
    cursor: grab;

    &:hover {
      transform: scale(1.5) !important;
    }
  }
`

export const Text = styled.p`
  padding: 0 ${space.md};
  color: ${color.text.normal};
  font-family: ${font.family.heading};
  font-size: ${font.size.root};
  font-weight: ${font.weight.bold};
  line-height: ${font.lineHeight.md};
  text-align: center;
  height: 3.5rem;
`
